import { Link, useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';

function ClientTopNav() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: 'home', label: 'Início' },
    { path: '/catalogo', icon: 'th-large', label: 'Catálogo' },
    { path: '/promocoes', icon: 'tag', label: 'Ofertas' },
    { path: '/categorias', icon: 'tags', label: 'Categorias' },
    { path: '/carrinho', icon: 'shopping-bag', label: 'Carrinho' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/home';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <div className="desktop-search-container">
        <SearchBar />
      </div>
      <nav className="top-nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`top-nav-item ${isActive(item.path) ? 'active' : ''}`}
          >
            <i className={`fas fa-${item.icon}`}></i>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </>
  );
}

export default ClientTopNav;

